// @flow
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'

import './styles.css'

const termsAndConditions = props => (
  <Grid fluid>
    <Row center='xs'>
      <Col className='main-container' xs={12} sm={12} md={12} lg={9}>
        <Row>
          <Col
            smOffset={1}
            className='go-back-btn'
            onClick={() => props.history.goBack()}
          />
        </Row>
        <Row center='xs'>
          <Col className='wink-top-logo' style={{ margin: 0 }} />
        </Row>
        <Row center='xs'>
          <Col className='tittle' style={{ marginBottom: 60 }}>
            Términos y condiciones
          </Col>
        </Row>
        <Row>
          <Col
            className='terms-and-conditions'
            smOffset={1}
            xs={12} sm={10} md={10} lg={10}
          >
            1. Esta promoción es válida hasta el 30 de septiembre
            o hasta la creación de 2,000 nuevas cuentas en Wink a
            través de los links de invitación enviados.
          </Col>
          <Col
            className='terms-and-conditions'
            smOffset={1}
            xs={12} sm={10} md={10} lg={10}
          >
            2. Cada usuario de Wink que envíe una invitación
            recibirá 5,000 colones por cada cuenta activa creada
            a través del link de invitación que le haya sido
            proporcionado.
          </Col>
          <Col
            className='terms-and-conditions'
            smOffset={1}
            xs={12} sm={10} md={10} lg={10}
          >
            3. Para efectos de esta promoción, se considerará
            como “cuenta activa” toda aquella que:
          </Col>
          <Col
            className='terms-and-conditions'
            smOffset={2} xsOffset={1}
            xs={12} sm={10} md={10} lg={10}
          >
            a. haya sido abierta a través de uno de los links únicos enviados, <br />
            b. haya activado su tarjeta de débito Wink, <br />
            c. tenga al menos 3 transacciones entrantes, y <br />
            d. tenga al menos un mes de haber sido abierta.
          </Col>
          <Col
            className='terms-and-conditions'
            smOffset={1}
            xs={12} sm={10} md={10} lg={10}
          >
            4. Cada usuario de Wink puede recibir hasta un máximo
            de 50,000 colones si 10 de las personas que invita
            crean cuentas activas en Wink a partir del link
            individual creado para esta promoción.
          </Col>
          <Col
            className='terms-and-conditions'
            smOffset={1}
            xs={12} sm={10} md={10} lg={10}
          >
            5. El link de invitación recibido por cada usuario es
            único, individual e intransferible. El usuario podrá
            utilizarlo para invitar a cuantas personas desee, pero
            no transferirlo a otras personas.
          </Col>
          <Col
            className='terms-and-conditions'
            smOffset={1}
            xs={12} sm={10} md={10} lg={10}
          >
            6. Los pagos a los usuarios de Wink que inviten a
            contactos que abran cuantas válidas se harán de manera
            automática, y se notificará a los usuarios cuando un
            pago haya sido depositado en sus cuentas.
          </Col>
          <Col
            className='terms-and-conditions'
            smOffset={1}
            xs={12} sm={10} md={10} lg={10}
          >
            7. Con el fin de evitar fraudes se investigará cualquier
            actividad sospechosa en la creación de nuevas cuentas.
            Wink se reserva el derecho de retener el pago de un
            incentivo en caso de que haya indicadores razonables
            sobre la creación de cuentas fraudulentas.
          </Col>
          <Col
            className='terms-and-conditions'
            style={{ marginBottom: 70 }}
            smOffset={1}
            xs={12} sm={10} md={10} lg={10}
          >
            8. Cualquier duda o consulta sobre esta promoción
            puede dirigirse a nuestros agentes de Servicio al
            Cliente a través del correo <a href='mailto:soporte@holawink.com'>
              soporte@holawink.com</a>.
          </Col>
        </Row>
      </Col>
    </Row>
  </Grid>
)

export default termsAndConditions



// WEBPACK FOOTER //
// ./src/pages/Referral/termsAndConditions.js